import { render } from "./AddKnowledge.vue?vue&type=template&id=13ef6c24"
import script from "./AddKnowledge.vue?vue&type=script&lang=js"
export * from "./AddKnowledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__